import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';
import { copyToClipboard } from '../../actions/citation';

if (process.browser) require('./CopyToClipboard.scss');

const canCopy = () =>
  document.createRange &&
  document.execCommand &&
  window.getSelection;

const copy = (target) => {
  const range = document.createRange();
  range.selectNodeContents(target);
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
  document.execCommand('copy');
};

class CopyToClipboard extends Component {
  state = {};

  componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      canCopy: canCopy(),
    });
  }

  componentWillUpdate(props) {
    if (props !== this.props) this.stopCopyTimeout();
  }

  componentWillUnmount() {
    this.stopCopyTimeout();
  }

  onClick = () => {
    copy(this.tag);
    this.startCopyTimeout();

    const {
      doc,
      citationStyle,
    } = this.props;

    this.props.copyToClipboard({
      doc,
      citationStyle,
    });
  }

  setCopyTimeout(copyTimeout) {
    this.setState({ copyTimeout });
  }

  startCopyTimeout() {
    this.setCopyTimeout(setTimeout(() => this.stopCopyTimeout(), 1000));
  }

  stopCopyTimeout() {
    const {
      copyTimeout,
    } = this.state;

    if (copyTimeout) {
      clearTimeout(copyTimeout);
    }

    this.setCopyTimeout(null);
  }

  render() {
    if (!this.state.canCopy) {
      return null;
    }

    const {
      data,
      className = '',
      fluid,
      track,
    } = this.props;

    const {
      copyTimeout,
    } = this.state;

    return (
      <div className={`copy-to-clipboard ${className}`}>
        <p
          className="copy-to-clipboard-hidden"
          ref={(el) => { this.tag = el; }}
          dangerouslySetInnerHTML={{ __html: data }}
        />
        <Button
          buttonStyle="basic"
          className={copyTimeout ? 'button-success' : ''}
          onClick={this.onClick}
          data-name="copy"
          fluid={fluid}
          track={track}
        >
          {copyTimeout && (
            <span><Icon name="check" />Copied</span>
          )}
          {!copyTimeout && 'Copy to clipboard'}
        </Button>
      </div>
    );
  }
}

const mapDispatchToProps = {
  copyToClipboard,
};

export default connect(null, mapDispatchToProps)(CopyToClipboard);



// WEBPACK FOOTER //
// ./src/universal/ui/components/CopyToClipboard/CopyToClipboard.js